import React from 'react';
import { achievementsData } from '../data/mock';
import { Calendar, ArrowRight } from 'lucide-react';

const AchievementCard = ({ achievement }) => {
  const altTextMap = {
    '1': 'Ruben P. Wargner onsite with engineering teams at major bridge construction project',
    '2': 'Ruben P. Wargner delivering keynote address at Global Infrastructure Summit',
    '3': 'Ruben P. Wargner receiving international leadership award for civil engineering excellence',
    '4': 'Ruben P. Wargner featured on Infrastructure Leaders Review magazine cover'
  };
  
  return (
    <div className="achievement-card">
      <div className="achievement-image-container">
        <img 
          src={achievement.image} 
          alt={altTextMap[achievement.id] || `${achievement.title} - Ruben P. Wargner achievement`}
          className="achievement-image"
        />
        <div className="achievement-year-badge">
          <Calendar size={14} />
          <span>{achievement.year}</span>
        </div>
      </div>
      <div className="achievement-content">
        <h3 className="achievement-title">{achievement.title}</h3>
        <p className="achievement-description">{achievement.description}</p>
        <div className="achievement-link">
          <span>View Project</span>
          <ArrowRight size={16} />
        </div>
      </div>
    </div>
  );
};

const AchievementGallery = () => {
  return (
    <section id="achievements" className="achievements-section">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Portfolio</span>
          <h2 className="heading-2">Achievement Gallery</h2>
          <p className="section-subtitle">Landmark projects that define a legacy of engineering excellence</p>
        </div>
        
        <div className="achievements-grid">
          {achievementsData.map((achievement) => (
            <AchievementCard key={achievement.id} achievement={achievement} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AchievementGallery;